var header = require( './sticky-header' );

var stone_filters = ( function( $ ) {

	var $filters,
		$open_links,
		$close_link,
		$form;

	var _init = function() {
		$filters          = $( '#stone-filters' );
		$open_links       = $( '.open-filters' );
		$close_link       = $filters.find( 'a.close' );
		$form             = $filters.find( 'form.stone-filter-form' );
		
		$open_links.on( 'click', function( e ) {
			e.preventDefault();
			_maybe_open_filters();
		} );

		$close_link.on( 'click', function( e ) {
			e.preventDefault();
			_close_filters();
		} );

		$( '#header' ).on( 'click', _close_filters );

		$form.find( '#stone-filters-submit' ).on( 'click', _submit_form );
	};

	var _maybe_open_filters = function() {
		if ( ! is_open() ) {
			_open_filters();
		} else {
			_close_filters();
		}
	};

	var _open_filters = function() {
		$filters.removeClass( 'closed' );
		$( 'html' ).addClass( 'open-filters' );

		setTimeout( function() {
			$filters.addClass( 'open' );
		}, 10 );

		_add_overlay();

		header.stick_header();
	};

	var _close_filters = function() {
		$( 'html' ).removeClass( 'open-filters' );
		$filters.removeClass( 'open' );

		setTimeout( function() {
			$filters.addClass( 'closed' );
			_remove_overlay();
		}, 500 );

		header.maybe_stick_header();
	};

	var _add_overlay = function() {
		var $overlay = $( '<div id="site-overlay"></div>' );

		$( '#content' ).append( $overlay );

		setTimeout( function() {
			$overlay.addClass( 'in' );
		}, 10 );

		$overlay.on( 'click', _close_filters );
	};

	var _remove_overlay = function() {
		$( '#content' ).find( $( '#site-overlay' ) ).removeClass( 'in' );

		setTimeout( function() {
			$( '#content' ).find( $( '#site-overlay' ) ).remove();
		}, 500 );
	};

	var is_open = function() {
		var $open = false;

		if ( $( 'html' ).hasClass( 'open-filters' ) ) {
			$open = true;
		}

		return $open;
	};

	var _submit_form = function( e ) {
		e.preventDefault();

		var checked_collections = $form.find( '.filter-section.collection input:checked' ),
			checked_colours     = $form.find( '.filter-section.colour input:checked' ),
			checked_brands      = $form.find( '.filter-section.brand input:checked' ),
			base_url            = $form.attr( 'action' ),
			collections         = '',
			colours             = '',
			brands              = '';

		console.log( checked_brands );

		if ( checked_collections.length > 0 ) {
			collections = '&collection=';

			$.each( checked_collections, function( i, input ) {
				collections = collections + ($( input ).val() + ',');
			} );

			collections = collections.replace( /,\s*$/, "" );
		}


		if ( checked_colours.length > 0 ) {

			colours = '&colour=';
			$.each( checked_colours, function( i, input ) {
				colours = colours + ($( input ).val() + ',');
			} );

			colours = colours.replace( /,\s*$/, "" );
		}

		if ( checked_brands.length > 0 ) {

			brands = '&brand=';
			$.each( checked_brands, function( i, input ) {
				brands = brands + ( $( input ).val() + ',');
			} );

			brands = brands.replace( /,\s*$/, "" );
		}

		var query_str = collections + colours + brands;

		window.location.href = base_url + '?' + query_str;
	};

	if ( $( '#stone-filters' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {
		is_open: is_open
	}

})( jQuery );

module.exports = stone_filters;